module.exports = "<md-card class=\"accordian checkout-card\" ng-class=\"{'accordian--light': $ctrl.light, 'accordian--closed': !$ctrl.open}\"> <md-card-title> <text-circle light-theme=\"$ctrl.light || !$ctrl.open\">{{$ctrl.stepNumber}}</text-circle> <md-card-title-text> <span class=\"checkout-card-heading\">{{$ctrl.headingText}}</span> </md-card-title-text> <div ng-transclude=\"headerContent\" ng-if=\"$ctrl.open\"></div> </md-card-title> <md-card-content ng-if=\"$ctrl.open\"> <div ng-transclude=\"content\"></div> </md-card-content> </md-card> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/accordian/accordian.html
// module id = 734
// module chunks = 0